<template>
  <details class="disclosure" :open="open">
    <summary>
      <span class="label">
        <slot name="label" />
      </span>
      <i class="bdg-icon caret-right" />
    </summary>
    <div class="content">
      <slot name="content" />
    </div>
  </details>
</template>

<script>
export default {
  name: "Disclosure",
  props: {
    open: Boolean
  },
  mounted() {
    this.$el.addEventListener("toggle", () => {
      this.$emit("toggled", this.$el.open);
    });
  }
};
</script>

<style lang="scss" scoped>
details.disclosure {
  @apply border-b border-lightgray bg-white;

  &:first-child {
    @apply border-t border-lightgray;
  }

  &:not([open]) {
    summary {
      @apply bg-lightgray-lighter;

      i {
        @apply text-blue;
      }
    }
  }

  &[open] {
    summary {
      @apply bg-blue text-white;
      & > i {
        transform: rotate(90deg);
      }
    }
  }

  summary {
    @apply px-5 py-3;

    list-style: none;

    @apply flex justify-between items-center py-3 pl-5 pr-2 outline-none;

    &::-webkit-details-marker {
      display: none;
    }

    span.label {
      @apply flex-grow;
    }

    & > i {
      transition: all 0.3s ease;
    }
  }
}
</style>
